import React from "react";
import { withTranslation } from "react-i18next";
import Modal from "../modal-new";
import OtherExerciseFields from "../../parts/other-exercise/OtherExerciseFields";
import { RillContext } from "../../rill/RillReact/share/base";

const {
  PARAMETER_OPTIONS: { SETS, FREEFORM, NONE, REPS, RPEAMRAP, LOAD },
} = require("../../constants");

const id = "modal-add-other-movement";

class AddOtherMovementModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    let initialState;
    if (!this.props.isNew) {
      const {
        movement,
        repMaximum,
        parameters,
        video,
        exerciseTypeField,
        primaryMuscleGroup,
        secondaryMuscleGroup,
        instructions,
      } = this.props.exercise || this.props.library[this.props.index];

      let parametersState = [];
      const parametersLength = parameters && parameters.length;

      switch (parametersLength) {
        case 1:
          parametersState = [...parameters, NONE, NONE, NONE];
          break;
        case 2:
          parametersState = [...parameters, NONE, NONE];
          break;
        case 3:
          parametersState = [...parameters, NONE];
          break;
        case 4:
          parametersState = [...parameters];
          break;

        default:
          parametersState = [NONE, NONE, NONE, NONE];
          break;
      }

      initialState = {
        movement: movement,
        repMaximum: repMaximum || "",
        parameters: parametersState,
        videoUrl: (video && video.url) || "",
        videoFile: null,
        videoOriginal: (video && video.videoOriginal) || "", // if there is an uploaded video
        exerciseTypeField: exerciseTypeField || "",
        primaryMuscleGroup: primaryMuscleGroup || "",
        secondaryMuscleGroup: secondaryMuscleGroup || "",
        instructions: instructions || "",
        freeFormSelected:
          parametersState.length > 0 && parametersState[0] === FREEFORM
            ? "0"
            : null,
        videoDeleteOtherExercise: null,
      };
    }

    this.state = Object.assign(
      {
        parameters: [SETS, REPS, RPEAMRAP, LOAD],
        freeFormSelected: null,
      },
      initialState
    );

    this.handleInputChange = this.handleInputChange.bind(this);
    this.cleanVideoField = this.cleanVideoField.bind(this);
    this.updateOtherExerciseParameters =
      this.updateOtherExerciseParameters.bind(this);
  }

  cleanVideoField() {
    this.setState({ videoOriginal: "", videoDeleteOtherExercise: true });
  }

  updateOtherExerciseParameters(parameters, freeFormSelected) {
    this.setState({ parameters, freeFormSelected });
  }

  handleInputChange(event) {
    const { value, name } = event.target;
    this.setState({
      [name]: value,
    });
  }

  render() {
    const {
      parameters,
      freeFormSelected,
      movement,
      repMaximum,
      instructions,
      exerciseTypeField,
      primaryMuscleGroup,
      secondaryMuscleGroup,
      videoUrl,
      videoFile,
      videoOriginal,
      videoDeleteOtherExercise,
    } = this.state;
    const {
      isNew,
      index,
      athlete,
      intensityMeasure,
      isRiR,
      isCatalog,
      exercise,
    } = this.props;
    let forAthlete = "";

    if (athlete) {
      forAthlete = `?forAthlete=${athlete._id}`;
    }
    let formURL = isNew
      ? `/actions/user/add-secondary${forAthlete}`
      : `/actions/user/edit-secondary/${index}${forAthlete}`;
    if (isCatalog) {
      formURL = `/actions/exercise-catalog/save/${
        exercise ? exercise._id : ""
      }`;
    }
    return (
      <form
        action={formURL}
        method="POST"
        encType="multipart/form-data"
        data-noreset
        id="add-other-exercise"
      >
        <input name="source" value="settings" type="hidden" />
        <input
          name="videoDeleteOtherExercise"
          value={videoDeleteOtherExercise}
          type="hidden"
        />
        <input type="hidden" name="indexOtherExercise" value={index} />

        <Modal
          name={id}
          key={id}
          width="600px"
          toClear={["exercise"]}
          title={
            isNew
              ? this.props.t("addOtherExercise.addTitle")
              : this.props.t("addOtherExercise.editTitle")
          }
          className={"add-movement-modal"}
        >
          <input type="hidden" name="primary" value="assistant" />

          {/* <div className="head">
            <h2 className="alt"></h2>
          </div> */}

          <div className="body">
            <div className="Create-New-Exercise">
              <div>
                <div className="w-1/2 mb-6">
                  <label>{this.props.t("addOtherExercise.nameLabel")}</label>
                  <input
                    className="text-input"
                    type="text"
                    name="movement"
                    placeholder={this.props.t(
                      "addOtherExercise.enterOtherExercise"
                    )}
                    onChange={this.handleInputChange}
                    value={movement}
                    maxLength="120"
                  />
                </div>
                <OtherExerciseFields
                  parameters={parameters}
                  freeFormSelected={freeFormSelected}
                  updateOtherExerciseParameters={
                    this.updateOtherExerciseParameters
                  }
                  videoFile={videoFile}
                  videoOriginal={videoOriginal}
                  videoUrl={videoUrl}
                  instructions={instructions}
                  handleInputChange={this.handleInputChange}
                  exerciseTypeField={exerciseTypeField}
                  primaryMuscleGroup={primaryMuscleGroup}
                  secondaryMuscleGroup={secondaryMuscleGroup}
                  cleanVideoField={this.cleanVideoField}
                  className={"form-row"}
                  form="add-other-exercise"
                  intensityMeasure={intensityMeasure}
                  isRiR={isRiR}
                  overlay
                />

                <div
                  className="column note-column-div"
                  data-col="1/1"
                  style={{ marginTop: "-10px" }}
                >
                  <div className="note">
                    {isNew
                      ? this.props.t("addOtherExercise.movementNoteAdded")
                      : this.props.t("addOtherExercise.movementNoteSaved")}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <footer className="foot">
            <a
              href="/actions/refresh?modal="
              role="button"
              data-button-type="text-white"
              data-action="cancel"
            >
              {this.props.t("common:cancel")}
            </a>
            <button data-button-type="primary" type="submit">
              {isNew ? this.props.t("common:add") : this.props.t("common:save")}
            </button>
          </footer>
        </Modal>
      </form>
    );
  }
}

AddOtherMovementModal.contextType = RillContext;

export { id };
export default withTranslation(["coaching-portal", "common"])(
  AddOtherMovementModal
);
